import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Reads the global maintenance mode flag (site_settings.maintenance_mode)
 * via the security-definer RPC get_maintenance_mode().
 *
 * The flag is re-checked on mount, when the tab regains focus and every
 * 30 seconds, so the site reacts quickly when admin toggles it.
 */
export const useMaintenanceMode = () => {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchMode = useCallback(async () => {
    try {
      const { data, error } = await supabase.rpc('get_maintenance_mode');
      if (!error) setMaintenanceMode(data === true);
    } catch (err) {
      console.error('Could not check maintenance mode:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMode();
    const interval = setInterval(fetchMode, 10000);
    const onFocus = () => fetchMode();
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onFocus);
    };
  }, [fetchMode]);

  return { maintenanceMode, loading, refresh: fetchMode };
};
